<template lang="pug">
  modal(:active='active' title='Incluir Pontos Avulso' @close="$emit('close')")
    div(slot='modal-body')
      form-group(label='Pontos' :validation="$v.params.pontos")
        money.form-input(v-model.number="$v.params.pontos.$model")
      form-group(label='Descrição' :validation="$v.params.descricao")
        input.form-input(v-model="$v.params.descricao.$model")
    div(slot='modal-footer')
      button.btn.btn-primary(:class="{'loading': loading}", @click='save', :disabled='$v.$invalid || loading')
        btn-content(name='save')
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import api from '@/api/produtividade/pontuacoes'

export default {
  props: {
    resumo: { type: Object, required: true },
    active: { type: Boolean, required: true },
  },

  data() {
    return {
      loading: false,
      params: {
        pontos: 0,
        descricao: '',
      },
    }
  },

  methods: {
    save() {
      this.loading = true
      api
        .createAvulso(this.resumo.id, this.params)
        .then(res => {
          this.$toaster.success('Salvo com sucesso.')
          this.loading = false
          this.$emit('close', res)
        })
        .catch(e => {
          this.$toaster.error(e.message)
          this.loading = false
        })
    },
  },

  validations: {
    params: {
      pontos: { required },
      descricao: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(100),
      },
    },
  },
}
</script>
